import { APIService } from '../../api/apiService';
import type {
  GetActivityLogsPayload,
  GetActivityLogsResponse,
} from '../../interfaces/ActivityLogApiService';

export class ActivityLogService extends APIService {
  /**
   * @desc Get files
   * @param payload
   * @return {Promise<* | undefined>}
   */
  getActivityLogs(payload: GetActivityLogsPayload): Promise<GetActivityLogsResponse> {
    return this.request('/getlogs', 'POST', { ...payload });
  }
}
